import React, { useContext, useState } from 'react';
import { CustomersContext, ICustomersContext } from '../../../../../customersState/customersContext';
import { RequestEntity, UserRoles, IItemCustomer } from 'types';
import { useRoleAccess } from 'hooks/useRoleAccess';
import Text from 'components/Text/Text';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import DataController from 'components/DataController/DataController';
import Info from './components/Info/Info';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IItem {
	data: IItemCustomer;
	index: number;
}

const Item: React.FC<IItem> = ({ data, index }) => {
	const { setIDForArchiving } = useContext<ICustomersContext>(CustomersContext);
	const [isOpenInfo, setIsOpenInfo] = useState<boolean>(false);
	const hasEditAccess = useRoleAccess([
		UserRoles.SUPER_USER,
		UserRoles.CLIENT_MANAGER,
		UserRoles.GROUP_MANAGER,
		UserRoles.TECHNICAL,
	]);
	const hasArchiveAccess = useRoleAccess([UserRoles.SUPER_USER]);

	const isDeleted = !!data.deletedDate;

	const containerClasses = classNames(style.container, {
		[style.openInfo]: isOpenInfo,
		[style.itemDeleted]: isDeleted,
	});
	const nameRowClasses = classNames(style.row, style.name);
	const restaurantsHeadingClasses = classNames(style.restaurants, style.row);
	const actionRowClasses = classNames(style.row, style.action, { [style.itemDeleted]: isDeleted });

	const handleClickInfo = () => {
		setIsOpenInfo(!isOpenInfo);
	};

	const handleSetIdForArchiving = () => {
		setIDForArchiving(data.id);
	};

	return (
		<div data-test={`Item-${index}`}>
			<div className={containerClasses}>
				<div className={nameRowClasses}>
					<div className={style.imgWrapper}>
						{isDeleted && <div className={style.imageOverlay} />}
						<ImgUploaderByEntityId
							resource={RequestEntity.Customers}
							entityID={data.filePath ? data.id : ''}
							photoSize="Small"
							loaderSize="small"
							noImageIdIcon="customerDefaultAvatar"
						/>
					</div>
					<Text
						className={style.customerName}
						translationKey={data.name}
						theme={!isDeleted ? 'neutralDark' : 'error'}
						withTooltip={true}
					/>
				</div>
				<Text
					className={restaurantsHeadingClasses}
					translationKey={String(data.restaurants.length)}
					theme={!isDeleted ? 'neutralDark' : 'error'}
					withTooltip={true}
				/>
				<div className={actionRowClasses}>
					<DataController
						onClickInfo={handleClickInfo}
						onClickArchive={hasArchiveAccess ? handleSetIdForArchiving : undefined}
						URLWithIDToEdit={hasEditAccess ? `/clients/customers/edit?customerID=${data.id}` : undefined}
						size="smallBtn"
						isOpenInfo={isOpenInfo}
					/>
				</div>
			</div>
			<Info isOpenInfo={isOpenInfo} data={data} />
		</div>
	);
};

export default Item;
